export * from './app-sidebar-footer.component';



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/components/app-sidebar-footer/index.ts